import { SET_FILTER_PARAMS } from '../actions/filters';

const defaultRiskAssessmentState = {
  selectedCounty: '',
  areaName: '',
  bounds: [],
  countySelectedFromAddress: false,
};

const filtersReducer = (state = defaultRiskAssessmentState, action) => {
  switch (action.type) {
    case SET_FILTER_PARAMS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default filtersReducer;
